export const palette = {
  blue: '#151ee9',
  blueLight: '#151ee94a',
  blueLightTwo: '#40b4ff3d',
  blueHover: '#151ee9c9',
  textGray: '#8c8c8c',
  infoLight: '#397bff4a',
  lightGray: '#ededed',
  successLight: '#31ffa761',
  success: 'green',
  error: 'red',
  errorLight: '#ff000033',
  lightWhiteBg: '#ededed',
};
